import { render, staticRenderFns } from "./ColumnOptions.vue?vue&type=template&id=e7fa3bba&scoped=true"
import script from "./ColumnOptions.vue?vue&type=script&lang=ts"
export * from "./ColumnOptions.vue?vue&type=script&lang=ts"
import style0 from "./ColumnOptions.vue?vue&type=style&index=0&id=e7fa3bba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fa3bba",
  null
  
)

export default component.exports